import { useTheme } from '@mui/material';
import * as hookz from '@react-hookz/web';
import { DirectoryTreeExplorer } from '#/features/directories';
import Panel from './panel';

function ExplorerPanel() {
  const theme = useTheme();
  const windowSize = hookz.useWindowSize();
  return (
    <Panel direction='left' className='p-2'>
      <DirectoryTreeExplorer
        width={'100%'}
        maxHeight={windowSize.height - theme.measurements.topBar.height}
      />
    </Panel>
  );
}

export default ExplorerPanel;
